/**
 * Reviews – Motion inView with stagger for card animations
 * Animates each review card with opacity and scale when block enters viewport
 */

import { inView, animate } from 'motion';

const SELECTOR = '.wp-block-acf-reviews';
const CARD_SELECTOR = '.wp-block-acf-reviews__card';

function init() {
  const blocks = document.querySelectorAll(SELECTOR);
  if (!blocks.length) return;

  blocks.forEach((block) => {
    const cards = block.querySelectorAll(CARD_SELECTOR);
    if (!cards.length) return;

    inView(
      block,
      () => {
        cards.forEach((card, i) => {
          animate(
            card,
            { opacity: 1, scale: 1 },
            { duration: 0.5, delay: i * 0.1, ease: 'easeOut' }
          );
        });
      },
      { once: true, amount: 0.2 }
    );
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
      card.style.opacity = '0';
      card.style.transform = 'scale(0.95)';
    });
    init();
  });
} else {
  document.querySelectorAll(CARD_SELECTOR).forEach((card) => {
    card.style.opacity = '0';
    card.style.transform = 'scale(0.95)';
  });
  init();
}
